<script setup lang="ts">
import { ref, watch } from 'vue';
import { useViewComposable } from '@/views/composable';
import Button from 'primevue/button';
import DatePicker from 'primevue/datepicker';
import MultiSelect from 'primevue/multiselect';

const props = defineProps<{
  isExternal: boolean;
}>();

const emits = defineEmits<{
  handleSubmitFilter: [value: any];
  handleResetFilter: [];
}>();

const { departments } = useViewComposable();
const isExpand = ref(true);
const filterNote = ref({
  departmentsCreated: [],
  departmentsTo: [],
  fromDate: '',
  toDate: ''
});
const dates = ref();

const handleExpand = (status: boolean) => {
  isExpand.value = !status;
};

const handleSubmitFilter = () => {
  emits('handleSubmitFilter', filterNote.value);
};

const handleResetFilter = () => {
  filterNote.value = {
    departmentsCreated: [],
    departmentsTo: [],
    fromDate: '',
    toDate: ''
  };
  dates.value = undefined;
  emits('handleResetFilter');
};

watch(
  dates,
  (newVal) => {
    if (newVal && newVal.length) {
      filterNote.value.fromDate = newVal[0];
      filterNote.value.toDate = newVal[1];
    }
  },
  { deep: true }
);

watch(
  () => props.isExternal,
  () => {
    filterNote.value = {
      departmentsCreated: [],
      departmentsTo: [],
      fromDate: '',
      toDate: ''
    };
    dates.value = undefined;
  }
);
</script>

<template>
  <div class="filter-note">
    <div class="header">
      <div>
        <Button v-if="isExpand" @click="handleExpand(isExpand)" :label="$t('common.filter')" icon="pi pi-chevron-down" class="p-button-text button-action"></Button>
        <Button v-if="!isExpand" @click="handleExpand(isExpand)" :label="$t('common.filter')" icon="pi pi-chevron-right" class="p-button-text button-action"></Button>
      </div>
    </div>
    <div v-if="isExpand">
      <div class="filter-wrapper">
        <div v-if="!isExternal" class="filter-item col-3">
          <p class="mb-3 ml-2 font-bold">{{ $t('my_quote.created_by_dept') }}</p>
          <MultiSelect
            id="departmentsCreated"
            class="note-select w-full"
            v-model="filterNote.departmentsCreated"
            display="chip"
            :options="departments"
            optionLabel="label"
            option-value="value"
            :placeholder="$t('quote_management.department')"
            :maxSelectedLabels="2"
            :selectionLimit="1"
          />
        </div>
        <div v-if="!isExternal" class="filter-item col-3">
          <p class="mb-3 ml-2 font-bold">{{ $t('my_quote.directed_to_dept') }}</p>
          <MultiSelect
            id="departmentsTo"
            class="note-select w-full"
            v-model="filterNote.departmentsTo"
            display="chip"
            :options="departments"
            optionLabel="label"
            option-value="value"
            :placeholder="$t('quote_management.department')"
            :maxSelectedLabels="2"
            :selectionLimit="1"
          />
        </div>
        <div class="filter-item col-3">
          <p class="mb-3 ml-2 font-bold">{{ $t('common.labels.date_range') }}</p>
          <DatePicker class="w-full" v-model="dates" selectionMode="range" dateFormat="dd-M-yy" :selectOtherMonths="true" :placeholder="$t('common.date_format_range')"></DatePicker>
        </div>
      </div>
      <div class="flex gap-3 ml-4">
        <Button id="submit-filter-id" :label="$t('common.labels.run')" class="mt-2 bg-primary" @click="handleSubmitFilter()"></Button>
        <Button id="reset-filter-id" :label="$t('common.labels.reset')" class="mt-2 bg-primary" @click="handleResetFilter()"></Button>
      </div>
    </div>
  </div>
</template>
